import { data } from '../../svg/VisibilityOff/data';
import { makeIcon } from '../makeIcon';

export const VisibilityOff = makeIcon(data, 'visibility_off', 'VisibilityOff');

export default VisibilityOff;
